// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const PhoneFaxLogs = t.struct({
    communicationType: t.String,
    countryCode: t.String,
    locationCode: t.String,
    phone: t.String,
    extension: t.String,
    personIdNumber: t.String,
    modifiedBy: t.String,
    timeStamp: t.String,
    remark: t.String
}, {
    defaultProps: {
        communicationType: '',
        countryCode: '',
        locationCode: '',
        phone: '',
        extension: '',
        personIdNumber: '',
        modifiedBy: '',
        timeStamp: '',
        remark: ''
    },
    name: 'PhoneFaxLogs',
    strict: true
});
